import React, { Component } from 'react'
import { Link, useParams } from 'react-router-dom'
import moment from 'moment'

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { error: '' }
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error: `${error.name}: ${error.message}` })
    console.log(error, errorInfo)
  }

  render() {
    const { error } = this.state
    if (error) {
      return <div>{error}</div>
    } else {
      return <>{this.props.children}</>
    }
  }
}
